import QRCode from "qrcode";
export default {
  data() {
    return {
      dialogVisible: false,
      timer: 0
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认取消支付？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    wxPay(order, diff_pay) {
      const root = process.env.ORDER_URL;
      const id_example = this.$store.state.id_example;
      const token_user = this.$store.state.user_id;
      this.$api.post(
        "order/orders/pay",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_order: order,
          pay_type: this.$store.state.webInfo.buy_point,
          tag: 2,
          diff_pay
        },
        res => {
          this.paybtn = false;
          if (res.data.code == 100) {
            this.$router.push({
              name: "Ordersucceed",
              params: { ordersn: res.data.data }
            });
          } else if (res.data.code == "200") {
            if (res.data.data == "point#500") {
              this.$confirm("积分不足，是否补齐差价？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.wxPay(order, 1);
                })
                .catch(() => {
                  this.$router.push({ name: "Myorder" });
                });
              return;
            }

            this.dialogVisible = true;
            var backurl = window.location.origin + "/ordersucceedwx";
            backurl = encodeURIComponent(backurl);

            var errback = window.location.origin + "/user/myorder/orderlist";
            errback = encodeURIComponent(errback);
            const appid = localStorage.getItem('login_code')
            const url = `${root}?id=${
              res.data.data.pay.log_id
            }&token_user=${token_user}&id_example=${id_example}&appid=${appid}&reurl=${backurl}&err=${errback}`;

            setTimeout(() => {
              const canvas = document.getElementById("paycanvas");
              QRCode.toCanvas(canvas, url, {
                width: 182
              });

              this.timer = setInterval(() => {
                this.getPayResult(res.data.data.order_number);
              }, 1000);
            }, 1);
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    getPayResult(order_number) {
      this.$api.post(
        "order/orders/status",
        {
          order_number: order_number,
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id
        },
        res => {
          if (res.data.code == 100) {
            if (res.data.data == 1) {
              clearInterval(this.timer);
              this.$router.push({
                name: "Ordersucceed",
                params: {
                  ordersn: order_number
                }
              });
            }
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/pay.js